$(function() {
    console.log('firing');
    $('.modal-fire').on('click', function(){
       let $id = $(this).data('id');
        console.log($id);
       $('[data-modal="'+ $id +'"]').css({'transform' : 'translateY(0%)'});
       $('[data-modal="'+ $id +'"] .team-modal__left-side').css({'transform' : 'translateX(0%)'});
       $('[data-modal="'+ $id +'"] .team-modal__right-side').css({'transform' : 'translateX(0%)'});
       $('body').css('overflow', 'hidden');
    });

    $('.modal-close').on('click', function(){
        let $id = $(this).data('id');
        console.log($id);
        $('.team-modal').css({'transform' : 'translateY(-100%)'});
        $('.team-modal .team-modal__left-side').css({'transform' : 'translateX(-100%)'});
        $('.team-modal .team-modal__right-side').css({'transform' : 'translateX(200%)'});
        $('body').css('overflow', 'inherit');
    });

});